import React from 'react';

import useCurrentUser from '../../../../hooks/useCurrentUser';
import useGroupSubscription from '../../../../hooks/useGroupSubscription';
import useTeam from '../../../../hooks/useTeam';
import { CORPORATE_SUBSCRIPTION_FORM_URL } from '../../../../utils/constants';
import { Spinner } from '../../../BaseUI';
import SubscriptionOverview from '../Gift/SubscriptionOverview';
import SettingsHeading from '../SettingsHeading';
import AddTeamMembers from './AddTeamMembers';
import EmailDomainForm from './EmailDomainForm';
import NameForm from './NameForm';
import SignupLink from './SignupLink';
import styles from './styles.module.scss';

export default function Team() {
  const { teamSetting, isTeamLoading } = useTeam();
  const { data: recipients } = useGroupSubscription({ type: 'Team Subscription' });
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const canAccessTeamSubscription =
    currentUser?.settings_access_obj?.group_sub_access || currentUser?.is_team_admin;
  const hasPersistedTeam = !!teamSetting?.team?.id;

  return (
    <>
      {isLoadingCurrentUser || isTeamLoading ? (
        <Spinner />
      ) : (
        <>
          {canAccessTeamSubscription ? (
            <div className={styles.teamSettings}>
              <div className={styles.teamSettingsSection}>
                <NameForm teamSetting={teamSetting} />
                {hasPersistedTeam && (
                  <div data-test="team-access-settings">
                    <div className={styles.description}>
                      <hr />
                      On your current plan, each additional team account costs $
                      {teamSetting.currentOffer.initialPrice}. If you are adding more than 10
                      people, please reach out to us{' '}
                      <a
                        href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=settings"`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        here
                      </a>{' '}
                      for bulk pricing.
                      <hr />
                    </div>

                    <SignupLink team={teamSetting?.team} />
                    <EmailDomainForm team={teamSetting?.team} />
                    <AddTeamMembers />
                  </div>
                )}
              </div>

              {hasPersistedTeam && (
                <div data-test="team-additional-settings">
                  <div className={styles.teamSettingsSection}>
                    <SettingsHeading title="Enterprise Functionality">
                      Need more enterprise functionality like SSO, advanced billing options, higher
                      seat counts, etc., reach out to{' '}
                      <a href="mailto:enterprise@theinformation.com">
                        enterprise@theinformation.com
                      </a>
                    </SettingsHeading>
                  </div>
                  <div className={styles.teamSettingsSection}>
                    <SettingsHeading title="Subscriptions">
                      You are currently supporting the following subscriptions for others to The
                      Information
                    </SettingsHeading>
                    {!!recipients && <SubscriptionOverview recipients={recipients} team={true} />}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div id="unaccessible-team-text" className={styles.teamSettings}>
              <div className={styles.teamSettingsSection}>
                <SettingsHeading title="The Information For Your Team">
                  Give your team the information and empower them with the information and
                  connections they need to win in tech — if you setup a team account, you can add
                  people to your &apos;group&apos;, create a custom signup link for your team, or
                  allow anyone with a valid email at your team&apos;s domain to access The
                  Information. You do not currently have access to this program, but if you would
                  like to get access email{' '}
                  <a className="link-blue" href="mailto:support@theinformation.com">
                    support@theinformation.com
                  </a>
                </SettingsHeading>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
